import { Injectable, InjectionToken, inject } from '@angular/core';
import { AiRun } from '../../core/models/ai.model';
import { AiPipelineService } from '../../core/services/ai-api.service';
import { AiRunnerInput, AiRunnerTarget } from './ai-runner.model';

/**
 * Quem cria a execução para um `target` do runner. O acompanhamento é sempre o mesmo (realtime de
 * `ia-runs` + `GET runs/{id}`), então todo executor devolve um `AiRun`.
 */
export interface AiRunExecutor {
  start(target: AiRunnerTarget, input: AiRunnerInput): Promise<AiRun>;
}

/** Pipeline cadastrada: `POST pipelines/{id}/run`. */
@Injectable({ providedIn: 'root' })
export class AiPipelineRunExecutor implements AiRunExecutor {
  private readonly pipelines = inject(AiPipelineService);

  start(target: AiRunnerTarget, input: AiRunnerInput): Promise<AiRun> {
    if (target.kind !== 'pipeline' || !target.pipelineId) {
      return Promise.reject(new Error('Selecione a pipeline.'));
    }
    return this.pipelines.run(target.pipelineId, input as Record<string, unknown>);
  }
}

/**
 * Chamada direta a um modelo (sem pipeline). Sem provider até o backend ter a rota: o runner mostra
 * o alvo `model` como indisponível. Para habilitar, prover este token com um `AiRunExecutor`.
 */
export const AI_MODEL_RUN_EXECUTOR = new InjectionToken<AiRunExecutor>('AI_MODEL_RUN_EXECUTOR');
